// extracted by mini-css-extract-plugin
export default {"wrapper":"MapPOIS_wrapper__WwLm3","map_title_style":"MapPOIS_map_title_style__jP5zq"};